import { ReactNode, RefObject } from 'react';

export default function SubPanelButton({
  ref,
  children,
  isOpen,
  isCurrent,
  onClick,
}: {
  children: ReactNode;
  isOpen?: boolean;
  isCurrent?: boolean;
  onClick: () => void;
  ref?: RefObject<HTMLButtonElement | null>;
}) {
  return (
    <button
      className={`w-full overflow-hidden rounded-2xl border p-4 transition-colors ${
        isOpen
          ? 'shadow-outline-blue-3 border-transparent bg-[#ECF4FF] dark:bg-[#282d33]'
          : isCurrent
            ? 'border-gray-45 dark:border-gray-60 bg-gray-15 dark:bg-gray-75 hover:shadow-menu'
            : 'border-gray-30 dark:border-gray-60 dark:bg-gray-90 hover:shadow-menu bg-white'
      }`}
      onClick={onClick}
      ref={ref}
    >
      {children}
    </button>
  );
}
